import Vue       from "vue"
import VueRouter from "vue-router"
import Home      from "../components/Home.vue"
import Slides    from "../components/Slides"
import Stage    from "../components/Stage"
import baseUrl   from "../constants/baseUrl"

Vue.use(VueRouter)

const routes = [
  { path: "/", component: Home },
  { path: "/:slug", component: Stage, name: "stage" },
]

export default new VueRouter({
  routes,
  mode: "history",
  base: baseUrl,
})
